import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import Asignacion from 'src/services/asignacion';
import { Button} from "@material-ui/core";
import {ButtonGroup} from "@material-ui/core";
import DatePicker from 'src/components/DatePicker';
import ModalDetalleAsignacion from 'src/components/asignacion/modal/ModalDetalleAsignacion';
import { IonAlert } from '@ionic/react';
import { Alert } from '@mui/material';
import { relative } from 'path';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'total', numeric: false, disablePadding: true, label: 'TOTAL' },
  { id: 'lun_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'lun_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'mar_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'mar_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'mie_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'mie_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'jue_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'jue_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'vie_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'vie_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'sab_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'sab_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
  { id: 'dom_ent', numeric: true, disablePadding: false, label: 'ENTRADA' },
  { id: 'dom_sal', numeric: true, disablePadding: false, label: 'SALIDA' },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
            <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />  
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
          style={{background:'#910434', color:'white'}}
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'right'}
            padding={headCell.disablePadding ? 'normal' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.primary.dark,
          backgroundColor: lighten(theme.palette.error.dark, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

  

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    }
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 150,

  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));


export default function EnhancedTable() {
  
  const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
   
    return (
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        {numSelected > 0 ? (
          <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
           Ha seleccionado {numSelected} 
          </Typography>
        ) : (
          <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
            Cortes de Asignacion
          </Typography>
        )}
    
       {numSelected > 0 ? (
          <>

          
          <DeleteIcon style={{position:'relative',top: '3px', background:'#910434', color:'white', height: 30, width:30, borderRadius: 35}}  onClick={() => {handleClicked(getId,formato)}}/>

          <Tooltip  title="Delete">
            <IconButton style={{display:'flex',top:'10px', left: 10}}  aria-label="delete"> 
            <DatePicker  className="half" value={Fecha} placeholder='Fecha Fin' setValue={setFecha} />
            </IconButton>
          </Tooltip>


          </>
        ) : (
          <Tooltip title="Filter list">
            <IconButton aria-label="filter list">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    );
  };
  
  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };
  
  const handleClicked = async (id,fecha_fin) => {

    const rowWithFechaInicio:any = rows.find((row) => 'fecha_inicio' in row)

    if (rowWithFechaInicio) {
      console.log('Se encontró una fila con "fecha_inicio":', rowWithFechaInicio['fecha_inicio']);
      
      if( rowWithFechaInicio['fecha_inicio'] > fecha_fin){
        setShowAlertMsg(true)
        setTimeout(() => {
          setShowAlertMsg(false);
        }, 5000); 
      }

        // eslint-disable-next-line no-restricted-globals
        const userConfirmed = confirm('¿Está seguro de Borrar este corte?');
        if(userConfirmed){
          setSelected([])
        id.map(() => {return JSON.stringify(id)})
        await Asignacion.borrarCorte(id,fecha_fin).then(response => {
          if (response.status === 200) {
            setAlertMessage(response.data.info || response.data.error);
            setShowAlert(true);
            setRefreshData(rows.map(()=>{return rows}))
          }else{
            return
          }
        })
        .catch((error) => {
          console.log(error.response.data.error)
          setShowAlertMsgCorte(true)
          setAlertMessageCorte(error.response.data.error);
          setTimeout(() => {
            setShowAlertMsgCorte(false);
          }, 5000); 

        });
      }
    
      
    }
  }

  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [selected, setSelected] = React.useState<any['']>([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<any['']>(5);
  const [Fecha, setFecha] = React.useState<Date | undefined>(new Date());
  const formato = JSON.stringify(Fecha?.toJSON()).slice(1,11)
 //llamada a la API
  const [rows, setRows] = useState([{}]);
  //mandamos la id por cada fila seleccionada
  const getId = selected.map((id) => { return id.id});
  //estado para actualizar la tabla
  const [refreshData, setRefreshData] = React.useState([{}])
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage , setAlertMessage] = useState('');
  const [showAlertMsg, setShowAlertMsg] = React.useState(false)
  const [showAlertMsgCorte, setShowAlertMsgCorte] = React.useState(false)
  const [alertMessageCorte, setAlertMessageCorte] = React.useState('')
  


  useEffect(() => {
    (async () => {
      
      await loadData()
      
    })();
  },[refreshData])
  
  
    const loadData = async () => {
    const url = await Asignacion.corteAsignacionOperario()
    const response = url
    setRows(response)
  

  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  
  const handleClick  = (event, id) => {
    
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
   
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
    
  };

 

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

   const handleChangeRowsPerPage = (event) => {
     setRowsPerPage(parseInt(event.target.value, 5));
     setPage(0);
   };

  //  const handleChangeDense = (event) => {
  //    setDense(event.target.checked);
  //  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>

      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        message={alertMessage}
        buttons={['cerrar']}
      />

        <EnhancedTableToolbar 
        numSelected={selected.length} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            // size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  const uniqueKey = index
                

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={uniqueKey}
                      selected={isItemSelected}
                      
                    >
                      {/* <TableCell  padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        /> 
                      </TableCell> */}
                      <TableCell component="th" id={labelId} align='center' scope="row" padding='none'>
                        {row.total_horas}

                      </TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">LUNES {row.lun_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">LUNES {row.lun_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">MARTES {row.mar_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">MARTES {row.mar_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">MIERCOLES {row.mie_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">MIERCOLES {row.mie_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">JUEVES {row.jue_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">JUEVES {row.jue_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">VIERNES {row.vie_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">VIERNES {row.vie_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">SABADO {row.sab_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">SABADO {row.sab_sal}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">DOMINGO {row.dom_ent}</TableCell>
                      <TableCell style={{padding:'15px',display:'inline-table flex', fontSize:16}} align="left">DOMINGO {row.dom_sal}</TableCell>
                      
                    </TableRow>
                  );
                })}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell  colSpan={6} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {showAlertMsg ? (<Alert severity="error"><strong>Error!</strong> La fecha de fin no puede ser anterior a la fecha de inicio.</Alert>) : null}
        {showAlertMsgCorte ? (<Alert severity="error"><strong>Error!</strong> {alertMessageCorte} </Alert>) : null}
        <ButtonGroup variant="contained" style={{display:'flex'}}  color="primary" aria-label="contained primary button group">
        <Button className="mt-2 mb-2" style={{ width:'100%'}}> <ModalDetalleAsignacion onConfirm={loadData}/></Button>            
        </ButtonGroup>
      </Paper>
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Comprimir Tabla"
      /> */}
      
      <div>
      </div>

    </div>
  );
}
